module.exports = __webpack_public_path__ + "static/media/unknown (1).38c03a5e.png";